//CoolEarthSDG111315.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCity, faGlobe, faTree, faPlus } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import MainLayout from '../../layouts/MainLayout';


const CoolEarthSDG111315 = () => {
  const location = useLocation();
  const authState = useSelector(state => state.authReducer);
  const [tasks, setTasks] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [name, setName] = useState('');
  
  const sdgs = [
    {
      id: 11,
      title: "SDG-11: Sustainable Cities & Communities",
      description:
        "Make cities inclusive, safe, resilient, and sustainable. Improve urban infrastructure, public transport, and disaster resilience.",
      icon: <faCity className="text-yellow-500 text-6xl mb-4" />,
      bgColor: "bg-yellow-100",
      unLink: "https://sdgs.un.org/goals/goal11"
    },
    {
      id: 13,
      title: "SDG-13: Climate Action",
      description:
        "Take urgent action to combat climate change and its impacts through awareness, policies, and sustainable practices.",
      icon: <faGlobe className="text-green-500 text-6xl mb-4" />,
      bgColor: "bg-green-100",
      unLink: "https://sdgs.un.org/goals/goal13"
    },
    {
      id: 15,
      title: "SDG-15: Life on Land",
      description:
        "Protect, restore, and promote sustainable use of ecosystems. Combat deforestation, desertification, and biodiversity loss.",
      icon: <faTree className="text-teal-500 text-6xl mb-4" />,
      bgColor: "bg-teal-100",
      unLink: "https://sdgs.un.org/goals/goal15"
    },
  ];

  const openUNLink = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <MainLayout>
        <div className="min-h-screen bg-green-800 flex flex-col items-center py-10 px-6">
          <h1 className="text-3xl font-bold text-white mb-6 text-center">
            UN Sustainable Development Goals
          </h1>
          <div className="grid md:grid-cols-1 gap-8 w-full max-w-6xl">
            {sdgs.map((sdg) => (
              <div
                key={sdg.id}
                className={`p-8 rounded-2xl shadow-lg transform transition duration-300 hover:scale-105 ${sdg.bgColor}`}
              >
                <div className="flex flex-col items-center">
                  {sdg.icon}
                  <h2 className="text-2xl font-semibold text-gray-800 mb-2 text-center">
                    {sdg.title}
                  </h2>
                  <p className="text-gray-600 text-center">{sdg.description}</p>
                  <p
                    className="text-blue-600 text-center mt-4 cursor-pointer underline"
                    onClick={() => openUNLink(sdg.unLink)}
                  >
                    Learn More
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </MainLayout>
    </>
  )
}

export default CoolEarthSDG111315;
